<template>
  <div class="main-doctor">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <h1 class="title-pages">DUPLICAR PRESCRIÇÃO DOS RESIDENTES</h1>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-2">
          <div class="text-center">
            <b>SELECIONAR TODOS OS RESIDENTES?</b>
            <b-form-group label="">
              <b-form-radio-group v-model="selectAll">
                <b-form-radio :value="true">SIM</b-form-radio>
                <b-form-radio :value="false">NÃO</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
          <div class="row">
            <div
              v-for="resident in residents"
              :key="resident.id"
              class="col-md-4 pt-0 pb-0"
            >
              <b-form-checkbox
                :value="resident.id"
                :checked="
                  resident_ids.find((resident_id) => resident_id == resident.id)
                "
                @change="handleChangeCheckbox($event, resident.id)"
                size="lg"
              >
                <div class="d-flex align-items-center">
                  <img
                    class="photo-url mr-2"
                    :src="
                      permission('read', 'resident_photo') && resident.photo_url
                        ? resident.photo_url
                        : require('../assets/user.png')
                    "
                  />
                  <p class="m-0 text-twelve">
                    {{ resident.name }}
                  </p>
                </div>
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="mt-2 v-clean p-2">
          <div class="row">
            <div class="col-md-12 pt-0 pb-0 text-center">
              <b>PERÍODO DA PRESCRIÇÃO</b>
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <h6 class="upper-text worksansr">DATA DE INÍCIO</h6>
              <input v-model="start_date" type="date" class="form-control" />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <h6 class="upper-text worksansr">DATA DE TÉRMINO</h6>
              <input v-model="end_date" type="date" class="form-control" />
            </div>
          </div>
        </div>
        <div class="mt-2 v-clean p-2">
          <div
            class="text-center"
            v-if="permission('write', 'resident_nurse_schedule')"
          >
            <b-form-checkbox v-model="schedule" switch>
              EXECUTAR O APRAZAMENTO?
              <b :class="[schedule ? 'c-success' : 'c-danger']"
                >({{ schedule ? "SIM" : "NÃO" }})</b
              >
            </b-form-checkbox>
          </div>
        </div>
        <div class="mt-2">
          <ErrorsMessages :errors="errors" />
          <div>
            <v-alert
              border="bottom"
              colored-border
              type="warning"
              elevation="2"
            >
              Será duplicada a última prescrição dos residentes selecionados.
            </v-alert>
          </div>
        </div>
        <div class="mt-2 text-right">
          <confirmation-dialog
            :disabled="btnDisabled"
            header-class="modal-header"
            message-title="Deseja realmente duplicar a prescrição dos residentes selecionados?"
            message-body="Ao confirmar, não é possível reverter em grupo, terá que fazer individualmente."
            open-class="btn-save"
            open-left-icon="fa-copy"
            open-text="DUPLICAR"
            @yes="execute"
          />
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar.vue";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired.vue";

import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";

import ConfirmationDialog from "../templates/Components/ConfirmationDialog.vue";

import api from "../services/api";

import toast from "../lib/ToastNotification";

import permission from "../lib/permission";

export default {
  name: "Doctor",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      selectAll: false,
      schedule: false,

      start_date: "",
      end_date: "",

      residents: [],
      resident_ids: [],

      errors: [],
      loading: false,
    };
  },

  computed: {
    btnDisabled() {
      let { loading, resident_ids, start_date, end_date } = this;

      if (loading) return true;
      if (!start_date) return true;
      if (!end_date) return true;
      if (resident_ids.length <= 1) return true;

      return false;
    },
  },

  watch: {
    selectAll() {
      if (this.selectAll) {
        this.resident_ids = this.residents.map(({ id }) => id);
      } else {
        this.resident_ids = [];
      }
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    retrieve() {
      if (permission("write", "resident_nurse_schedule")) {
        this.schedule = true;
      }

      this.getResidents();
    },

    handleChangeCheckbox(checked, resident_id) {
      let { resident_ids } = this;
      if (checked) {
        let find = resident_ids.find((id) => id == resident_id);
        if (!find) {
          resident_ids.push(resident_id);
        }
      } else {
        resident_ids.map((id, key) => {
          if (id == resident_id) {
            resident_ids.splice(key, 1);
          }
        });
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/active-residents");

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          for (let resident of residents) {
            resident.checked = true;
          }

          this.resident_ids = [];
          this.residents = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async execute() {
      try {
        this.loading = true;

        let { resident_ids, schedule, start_date, end_date } = this;

        let data = { resident_ids, schedule, start_date, end_date };

        let response = await api.post(
          "/rest-home/duplicate/group-prescription-medicines",
          data
        );

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.selectAll = false;
          this.resident_ids = [];
          this.start_date = "";
          this.end_date = "";
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.main-doctor .photo-url {
  width: 25px;
  height: 25px;
  object-fit: cover !important;
  border-radius: 100%;
}
</style>